import React from 'react'
import CardUI from '../../../widgets/layout/CardUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import LoanRemarksCreateModalSF from '../../../components/superUser/loan/util/LoanRemarksCreateModalSF.js'
import LoanRemarksUpdateModalSF from '../../../components/superUser/loan/util/LoanRemarksUpdateModalSF.js'
import './ReportCardPage.css'

const LegalRemarksPageUI = ({ context, errorList,
  loan, legal, onRefreshClick, createMode, onCancelRemarksClick, onCreateRemarksClick, objectCode, objectId, legalRemarksList,
  updateRemarksMode, onUpdateRemarksClick, selectedRemarks, selectedRemarksId, selectedAction, selectedActionDateISO, selectedActionStatus
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_repc'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='legalRemarks'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <IconButtonUI icon='icon-plus' onClick={onCreateRemarksClick} />
              <span className='g_m_left_100 g_large'><b>Legal remarks</b></span>
            </span>
          }
          right={<span />}
        />

        <LegalRemarksUI
          loan={loan}
          legal={true}
          context={context}
          createMode={createMode}
          onCreateRemarksClick={onCreateRemarksClick}
          onCancelRemarksClick={onCancelRemarksClick}
          onRefreshClick={onRefreshClick}
          objectCode={objectCode}
          objectId={objectId}
          legalRemarksList={legalRemarksList}
          updateRemarksMode={updateRemarksMode}
          onUpdateRemarksClick={onUpdateRemarksClick}
          selectedRemarks={selectedRemarks}
          selectedRemarksId={selectedRemarksId}
          selectedAction={selectedAction}
          selectedActionStatus={selectedActionStatus}
          selectedActionDateISO={selectedActionDateISO}
        />

      </div>
    }
  </SuperUserLoanPageSF>

const LegalRemarksUI = ({ context, loan, legal, onRefreshClick,
  createMode, onCancelRemarksClick, onCreateRemarksClick, objectCode, objectId, legalRemarksList,
  updateRemarksMode, onUpdateRemarksClick, selectedRemarks, selectedRemarksId, selectedAction, selectedActionDateISO, selectedActionStatus
}) =>
  <CardUI>
    <table className='g_full_width g_m_top_20'>
      <thead>
        <tr>
          <th className='g_p_right_100'>Date</th>
          <th className='g_p_left_100'>Remarks</th>
          <th className='g_p_left_100'>Actions</th>
          <th className='g_p_left_100'>Actions Date</th>
          <th className='g_p_left_100'>Actions Status</th>
        </tr>
      </thead>
      <tbody>
        {legalRemarksList && legalRemarksList.length > 0 && (
          legalRemarksList.map((remarks, i) => (
            <tr key={i}>
              <td className='g_p_right_100' style={{ whiteSpace: 'nowrap', verticalAlign: 'top' }} >{remarks.remarksDateF}</td>
              <td className='g_p_left_100'>{remarks.remarks}</td>
              <td className='g_p_left_100'>{remarks.action}</td>
              <td className='g_p_left_100'>{remarks.actionDateISO}</td>
              <td className='g_p_left_100'>{remarks.actionStatus}</td>
              <td className='g_p_left_100'>
                <span className="icon icon-pencil g_cursor_pointer g_muted" onClick={onUpdateRemarksClick}
                  data-object-id={remarks.objectId} data-date={remarks.remarksDateF}
                  data-remarks={remarks.remarks} data-action={remarks.action} data-action-date={remarks.actionDateISO} data-action-status={remarks.actionStatus} data-remarks-id={remarks.remarksId} style={{ verticalAlign: 'top' }}></span>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>

    <LoanRemarksCreateModalSF
      context={context} loan={loan} legal={legal}
      objectCode={objectCode} objectId={objectId}
      updateMode={createMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick}
    />

    <LoanRemarksUpdateModalSF
      context={context} loan={loan} legal={true}
      selectedRemarks={selectedRemarks} selectedRemarksId={selectedRemarksId}
      updateMode={updateRemarksMode} onCancelClick={onCancelRemarksClick}
      onRefreshClick={onRefreshClick} selectedAction={selectedAction} selectedActionDateISO={selectedActionDateISO}
      selectedActionStatus={selectedActionStatus}
    />
  </CardUI>

export default LegalRemarksPageUI
